import {
  collection,
  getCountFromServer,
  query,
  where,
} from 'firebase/firestore';
import { db } from '../firebase';

const statsCache = new Map();
const activeRequests = new Map();
const TTL = 5 * 60 * 1000;

const loadCount = async (key, request) => {
  const cached = statsCache.get(key);
  if (cached && Date.now() - cached.timestamp < TTL) return cached.data;
  if (activeRequests.has(key)) return activeRequests.get(key);

  const promise = request()
    .then((data) => {
      statsCache.set(key, { data, timestamp: Date.now() });
      return data;
    })
    .finally(() => activeRequests.delete(key));

  activeRequests.set(key, promise);
  return promise;
};

export const loadCommentsCount = (uid) => loadCount(
  `profile-comments:${uid}`,
  async () => {
    const snapshot = await getCountFromServer(query(
      collection(db, 'comments'),
      where('userId', '==', uid)
    ));
    return snapshot.data().count;
  }
);

export const loadAuthorArticlesCount = (uid) => loadCount(
  `profile-author-news:${uid}`,
  async () => {
    const snapshot = await getCountFromServer(query(
      collection(db, 'news'),
      where('authorId', '==', uid)
    ));
    return snapshot.data().count;
  }
);

export const resetProfileStatsCacheForTests = () => {
  statsCache.clear();
  activeRequests.clear();
};
